<template>
	<section class="mx-content  will-change " :data-scroll-section="inner == 'false'" ref="mapImgWrap">
		<div class="mb-12 pt-10 xl:pt-[120px]" v-if="blockData.title">
            <h2 class="text-4xl xl:text-heading text-center tracking-[2px] leading-none px-8  mb-7 w-full" v-html="blockData.title"></h2>
        </div>
		<!-- canvas-wrap -->
		<div class="h-[67vh] rounded-lg overflow-hidden relative">

			<canvas ref="mappedCanvas" class="mapped-canvas" width="0" height="0"></canvas>

			<div class="html-objects-holder">
				<div ref="poiHolder" class="poi-data-holder" v-for="(poi, index) in blockData.mapped_image.shapes.filter( obj => obj.select == 'POI' )" :key="index" :data-left="poi.shape_data.x" :data-top="poi.shape_data.y">
					<div class="poi-tip-holder" :class="poi.orientation">
						{{poi.poi[0].post_title}}
					</div>
				</div>
			</div>

		</div>
		<!-- ./canvas-wrap -->
	</section>
</template>

<script>
import {fabric} from 'fabric'

//code used to disable scroll snatch by canvas
(function() {
	var addListener = fabric.util.addListener,
			removeListener = fabric.util.removeListener,
			addEventOptions = { passive: false };

	fabric.util.object.extend(fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {
		_onTouchStart: function(e) {
			//e.preventDefault();
			if (this.mainTouchId === null) {
				this.mainTouchId = this.getPointerId(e);
			}
			this.__onMouseDown(e);
			this._resetTransformEventData();
			var canvasElement = this.upperCanvasEl,
					eventTypePrefix = this._getEventPrefix();
			addListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
			addListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
			// Unbind mousedown to prevent double triggers from touch devices
			removeListener(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
		}
	});
})();

export default {
	name: "MappedImage",
	data() {
		return {
			canvas: false,
			image: false,
			point: false,
			initialDown: false,
			moved: false
		}
	},
	mounted() {
		this.canvas = new fabric.Canvas(this.$refs.mappedCanvas)
		this.canvas.selection = false
		this.canvas.allowTouchScrolling = true
		this.loadBackgroundImage()
		if ( !this.$root.isMobile ) {
			window.addEventListener( 'resize', this.handleResize )
		}
		window.addEventListener( 'blur', this.handleWindowBlur )
		setTimeout( () => { this.addCanvasListeners() }, 1000 )

		//disable scroll snatch
		document.querySelectorAll( 'canvas' ).forEach( (el) => {
			el.style.touchAction = 'manipulation'
		} )
	},
	methods: {
		loadBackgroundImage() {
			let group = []
			fabric.loadSVGFromURL(this.endpoints.template_url + '/assets/img/mapped-point.svg', (object, options) => {
				this.point = new fabric.Group(group)
			}, (item, object) => {
				group.push(object)
			})
			fabric.Image.fromURL(this.blockData.mapped_image.image_settings.url, (myImg) => {
				myImg.editable = false
				myImg.selectable = false
				myImg.hoverCursor = 'grab'
				this.canvas.add(myImg)
				this.image = myImg
				setTimeout(() => {
					this.addObjects()
					this.handleResize()
				}, 500)
			})
		},
		addCanvasListeners() {
			this.canvas.on( 'mouse:down', this.handlerDown )
			this.$el.addEventListener( 'touchstart', this.handlerDown )

			this.canvas.on( 'mouse:move', this.handlerMove )
			this.$el.addEventListener( 'touchmove', this.handlerMove )

			this.canvas.on( 'mouse:up', this.handlerUp )
			this.$el.addEventListener( 'touchend', this.handlerUp )
		},
		handlerDown( opt ) {
			var evt = typeof( opt.e ) == 'undefined' ? opt : opt.e
			var points = this.getEventPoints( evt )

			if ( points ) {
				this.initialDown = points
				this.canvas.isDragging = true
				this.canvas.selection = false
				this.canvas.lastPosX = points.x
				this.canvas.lastPostY = points.y
				this.image.hoverCursor = 'grabbing'
				this.fixPanAndZoom()
			}
		},
		handlerMove( opt ) {
			if ( this.canvas.isDragging ) {
				var evt = typeof( opt.e ) == 'undefined' ? opt : opt.e
				var points = this.getEventPoints( evt )
				var vpt = this.canvas.viewportTransform
				vpt[4] += points.x - this.canvas.lastPosX
				vpt[5] += points.y - this.canvas.lastPostY
				this.canvas.requestRenderAll()
				this.canvas.lastPosX = points.x
				this.canvas.lastPostY = points.y
				if ( Math.abs( this.initialDown.x - points.x ) > 10 || Math.abs( this.initialDown.y - points.y ) > 10 ) {
					this.moved = true
				}
				this.fixPanAndZoom()
			}
		},
		handlerUp( opt ) {
			this.canvas.setViewportTransform( this.canvas.viewportTransform )
			this.canvas.isDragging = false
			this.image.hoverCursor = 'grab'
			this.fixPanAndZoom()
			setTimeout( () => {
				this.moved = false
			}, 500 )
		},
		getEventPoints( evt ) {
			var x = 0
			var y = 0
			if ( evt instanceof TouchEvent ) {

				/*if ( evt.changedTouches.length < 2 ) {
					return false
				}*/

				evt.changedTouches.forEach( ( el ) => {
					x += el.clientX
					y += el.clientY
				} )
				x = x / evt.changedTouches.length
				y = y / evt.changedTouches.length
			} else if ( evt instanceof MouseEvent ) {
				x = evt.clientX
				y = evt.clientY
			}
			return {
				x: x,
				y: y
			}
		},
		handleWindowBlur( e ) {
			this.canvas.setViewportTransform( this.canvas.viewportTransform )
			this.canvas.isDragging = false
			this.image.hoverCursor = 'grab'
			this.fixPanAndZoom()
		},
		fixPanAndZoom() {
			var vpt = this.canvas.viewportTransform

			//fix x axis
			if ( vpt[4] >= 0 ) {
				vpt[4] = 0
			} else if ( vpt[4] < this.canvas.getWidth() - this.image.width * this.canvas.getZoom() ) {
				vpt[4] = this.canvas.getWidth() - this.image.width * this.canvas.getZoom()
			}

			//fix y axis
			if ( vpt[5] >= 0 ) {
				vpt[5] = 0
			} else if ( vpt[5] < this.canvas.getHeight() - this.image.height * this.canvas.getZoom() ) {
				vpt[5] = this.canvas.getHeight() - this.image.height * this.canvas.getZoom()
			}

			this.positionPoiElements()
		},
		addObjects() {
			var fontFamily = window.current_language == 'ru_RU' ? 'Times New Roman' : 'Canela'
			this.blockData.mapped_image.shapes.forEach((el) => {
				el.shape_data = JSON.parse(el.shape_data)
				switch (el.select) {
					case 'Area': {
						var poly = new fabric.Polygon(el.shape_data.points, {
							fill: this.getRgba(el.color),
							selectable: false,
							id: el.shape_data.id,
							objectCaching: false,
							olvidar: "olvidar",
							stroke: "rgba(255, 255, 255, 0.8)",
							strokeWidth: 2,
							type: 'polygon',
							vueData: el,
							hoverCursor: 'pointer',
							perPixelTargetFind: true
						})
						this.canvas.add(poly)
						poly.on('mouseup', this.handleClick)

						var polyCenter = poly.getCenterPoint()

						var text = new fabric.Text(el.name, {
							left: polyCenter.x,
							top: polyCenter.y,
							fill: 'white',
							selectable: false,
							vueData: el,
							hoverCursor: 'pointer',
							fontSize: 20,
							originX: 'center',
							originY: 'center',
							fontFamily: fontFamily
						})
						this.canvas.add(text)
						text.on('mouseup', this.handleClick)
						break
					}
					case 'POI': {
						/*var poi = fabric.util.object.clone(this.point)
						poi.set('left', el.shape_data.x - poi.width)
						poi.set('top', el.shape_data.y - poi.height)
						poi.set('vueData', el)
						poi.set('type', 'poi')
						poi.set('hoverCursor', 'default')
						poi.set('objectCaching', false)
						poi.set('perPixelTargetFind', true)
						poi.set('selectable', false)
						poi.set('width', 2 * poi.width)
						poi.set('height', 2 * poi.height)
						this.canvas.add(poi)*/
						/* poi.on('mouseover', this.handleHover) */
						/*var text = new fabric.Text(el.poi[0].post_title, {
							left: el.shape_data.x,
							top: el.shape_data.y + 30,
							fill: 'white',
							selectable: false,
							vueData: el,
							hoverCursor: 'default',
							fontSize: 20,
							originX: 'center',
							fontFamily: fontFamily
						})
						this.canvas.add(text)*/
						break
					}

				}
			})
			this.canvas.renderAll()
		},
		handleResize() {
			let cW = this.$refs.mapImgWrap.clientWidth
			let cH = this.$refs.mapImgWrap.clientHeight
			let iW = this.image.width
			let iH = this.image.height

			var vpt = this.canvas.viewportTransform
			if ( this.$root.isMobile ) {
				vpt[4] = ( cW - iW ) / 2
			}

			let vS = cH / iH
			let hS = cW / iW

			let s = Math.max( hS, vS )

			var yOffset = - ( ( iH - cH ) / 2 ) * s
			vpt[5] = yOffset

			this.canvas.setZoom( s )

			this.canvas.setWidth(cW)
			this.canvas.setHeight(cH)

			this.positionPoiElements()
		},
		positionPoiElements() {
			if ( typeof( this.$refs.poiHolder ) === 'undefined' ) {
				return;
			}
			this.$nextTick( () => {
				var vpt = this.canvas.viewportTransform
				this.$refs.poiHolder.forEach( (el) => {
					el.style.top = el.dataset.top * this.canvas.getZoom() + vpt[5] + 'px'
					el.style.left = ( parseFloat( el.dataset.left ) + this.point.width/2) * this.canvas.getZoom() + vpt[4] + 'px'
				} )
			} )
		},
		handleClick(e) {
			if ( !this.moved ) {
				window.open(e.target.vueData.cta.url, '_blank').focus()
			}
		},
		getRgba(color) {
			let result
			switch (color) {
				case "Red":
					result = "rgba(255, 0, 0, 0.1)"
					break;
				case "Green":
					result = "rgba(0, 255, 0, 0.1)"
					break;
				case "Blue":
					result = "rgba(0, 0, 255, 0.1)"
					break;
				default:
					result = "rgba(255, 0, 0, 0.1)"
					break;
			}
			return result
		}
	}
}
</script>

<style scoped>
.poi-data-holder {
	position: absolute;
}
.poi-tip-holder {
	background-color: #1A3546;
	color: #fff;
	padding: 8px 15px;
	border-radius: 25px;
	font-size: 0.8rem;
}
.poi-tip-holder.top {
	transform: translateX(-50%) translateY(-30px);
}
.poi-tip-holder.bottom {
	transform: translateX(-50%) translateY(20px);
}
.poi-tip-holder:after {
	content: '';
	display: block;
	width: 12px;
	height: 12px;
	background-color: #1A3546;
	position: absolute;
	left: 50%;
	transform: rotate(45deg);
	margin: -6px 0 0 -6px;
}
.poi-tip-holder.top:after {
	top: 100%;
}
.poi-tip-holder.bottom:after {
	top: 0%;
}
</style>
